import { render } from "./ADataTableServer.vue?vue&type=template&id=6b2108e4"
import script from "./ADataTableServer.vue?vue&type=script&lang=js"
export * from "./ADataTableServer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__